<template>
  <div class="mlistsimple-container hscroll">
    <table class="table">
      <thead>
        <tr class="tr-head">
          <slot name="ths"></slot>
        </tr>
      </thead>
      <draggable v-if="dragable" tag="tbody" :list="items2" handle=".handle">
        <tr v-for="(item, indexItem) in items2" :key="item[itemValue]" :class="getTrClass(item)" @click="onitemclick(item, indexItem, $event)">
          <slot name="tds" :item="item"></slot>
        </tr>
      </draggable>

      <tbody v-if="!dragable">
        <tr v-for="(item, indexItem) in items2" :key="item[itemValue]" :class="getTrClass(item)" @click="onitemclick(item, indexItem, $event)">
          <slot name="tds" :item="item"></slot>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
// @Marina j'ai créé cette objet car il est bien différent de MList ! En effet MList a beaucoup de complexité qui ne sert à rien ici ! Il faudra peut-être par contre rajouter ici un système de paging, on verra...
export default {
  name: "mlistsimple",
  // components: { draggable },
  props: {
    items: {
      default: function() {
        return [];
      },
      type: Array
    },
    styleItemSelected: {
      default: false,
      type: Boolean
    },
    dragable: {
      default: false,
      type: Boolean
    },
    current: {
      default: "",
      type: [String, Number]
    },
    itemValue: {
      default: "",
      type: String
    },
    pagging: {
      default: false,
      type: Boolean
    },
    limit: {
      default: 100,
      type: Number
    },
    total: {
      default: 0,
      type: Number
    },
    skip: {
      default: 0,
      type: Number
    },
    itemHeight: {
      default: 30,
      type: Number
    },
    bgstrip1: {
      default: false,
      type: Boolean
    },
    item_height: {
      // small | medium | large
      type: String,
      default: "large"
    }
  },
  mounted() {
    if (!this.items) return;
    // console.log("this.items", this.items);
    if (this.limit > 0) {
      this.items2 = this.items.slice(0, this.limit);
    } else {
      this.items2 = this.items;
    }
    this.setCurrent();
    //this.update(0);
  },
  data() {
    return {
      scrollTop: 0,
      // skip: 0,
      timerScroll: null,
      list: [
        { name: "John", text: "", id: 0 },
        { name: "Joao", text: "", id: 1 },
        { name: "Jean", text: "", id: 2 }
      ],
      dragging: false,
      items2: [],
      itemSelected: {}
    };
  },
  watch: {
    // current(val) {
    //   this.$forceUpdate();
    // },
    items(val) {
      // console.log("this.items2", this.items);
      if (this.limit > 0) {
        this.items2 = this.items.slice(0, this.limit);
      } else {
        this.items2 = this.items;
      }
      this.setCurrent();
      // console.log("this.current", this.current);
      //      this.$nextTick(() => {});
    },
    total(val) {
      // this.calcPadding();
    },
    limit(val) {
      // console.log("this.items3", this.items);
      if (val > 0) {
        this.items2 = this.items.slice(0, val);
      } else {
        this.items2 = this.items;
      }
      this.$nextTick(() => {});
    }
  },
  computed: {
    // itemHeight2() {
    //   return this.itemHeight - 0;
    // },
    draggingInfo() {
      return this.dragging ? "under drag" : "";
    }
  },
  components: {},
  methods: {
    setCurrent() {
      if (this.current) {
        for (let i = 0; i < this.items2.length; i++) {
          const it = this.items2[i];
          if (it[this.itemValue] == this.current) this.itemSelected = it;
        }
      } else this.itemSelected = this.items2[0];
    },
    getTrClass(item) {
      // console.log("this.current", this.current);
      let cls = "";
      if (this.current == item[this.itemValue]) cls += " active";
      if (item.mListSimpleTrClass) cls += " " + item.mListSimpleTrClass;
      if (this.styleItemSelected && item === this.itemSelected) cls += " item-selected";
      return cls;
    },
    update(scrollTop) {
      //this.$nextTick(() => {});
    },
    // scrollToTop() {
    //   this.$refs.container.scrollTop = 0;
    // },
    // onscroll(evt, arg2) {
    //   // console.log("evt", evt.target.scrollTop);
    //   if (this.timerScroll) window.clearTimeout(this.timerScroll);
    //   this.timerScroll = window.setTimeout(() => {
    //     this.scrollTop = evt.target.scrollTop;
    //     let skip = Math.floor(this.scrollTop / this.itemHeight);
    //     this.$emit("changerange", skip, this.scrollTop);
    //   }, 100);
    // },
    onitemclick(item, indexItem, evt) {
      if (this.styleItemSelected) {
        this.itemSelected = item;
      }
      this.$emit("itemclick", item, indexItem, evt);
    }
  }
};
</script>

<style lang="scss">
@import "../scss/styles.scss";

.mlistsimple-item {
  cursor: pointer;
}
.mlistsimple-container {
  font-size: 12px;
}
// @import "../sass/variables.scss";
// .mlistsimple-container {
//   table {
//     tr {
//       td,
//       th {
//       }
//     }
//     thead {
//       th {
//       }
//     }
//     tbody {
//       tr {
//       }
//     }
//   }
// }

.table tr:nth-child(odd) {
  background-color: #f7f7f7;
}
.table {
  thead th {
    color: $emotivi-blue;
    text-transform: uppercase;
    border-top: 0;
  }
  thead .tr-head {
    background-color: #fff;
  }
  tbody tr {
    cursor: pointer;
  }
  tbody tr:hover {
    background-color: $emotivi-green-light;
  }
}
.handle {
  float: left;
  padding-top: 8px;
  padding-bottom: 8px;
}
input {
  display: inline-block;
  width: 50%;
}
.text {
  margin: 20px;
}
.item-selected {
  background-color: $emotivi-green !important;
}
</style>
